import { Pipe, PipeTransform } from '@angular/core';
import { formatDDMMYYYY } from '../date-utils';

@Pipe({
    name: 'dataFormatada'
})
export class DataFormatadaPipe implements PipeTransform {
    //Transforma datas no formato aaaa-mm-dd para dd/mm/aaaa ou Date para dd/mm/aaaa

    transform(value: string | Date | null | undefined, ...args: any[]): string {
        // converte any para string
        if (!value) {
            return '';
        } else if (value instanceof Date) {
            return formatDDMMYYYY(value);
        } else {
            const fatores = value.toString().split('-');

            if (fatores && fatores.length == 3) {
                const ano = fatores[0];
                const mes = fatores[1];
                const dia = fatores[2];
                return dia + '/' + mes + '/' + ano;
            } else {
                return '';
            }
        }
    }
}
